export enum RemitDetails {
  GET_REMIT_DETAILS = "GET_REMIT_DETAILS",
  GET_REMIT_DETAILS_SUCCESS = "GET_REMIT_DETAILS_SUCCESS",
  GET_REMIT_DETAILS_FAIL = "GET_REMIT_DETAILS_FAIL",

  SET_REMIT_META_DATA = "SET_REMIT_META_DATA",
}
